import DriverRatings from './review';

function App() {
  return (
    <div className="App">
      <DriverRatings />
    </div>
  );
}

export default App;